import { apiConfigured, clientLogin } from './api.js'
import { isClientLoggedIn, setClientSession } from './clientAuth.js'

/**
 * Card de login cliente reutilizable (ruta /cliente y modal).
 */
export function clientLoginCardHtml({
  formId = 'client-login-form',
  msgId = 'client-login-msg',
  emailId = 'client-email',
  passwordId = 'client-password',
  showBack = true,
  showIcon = true,
  variant = 'page',
  title = 'Acceso Cliente',
  lead = 'Entra al portal de tu organización: estado de la instalación, red y contadores.',
  submitLabel = 'Entrar al portal',
} = {}) {
  const heading = variant === 'home' ? 'h2' : 'h1'
  const wrapClass = variant === 'home' ? 'home-login-embed' : 'portal-login-page'
  const cardClass =
    variant === 'home' ? 'home-login-card portal-card' : 'portal-login-card portal-card'
  return `
    <div class="${wrapClass}">
      <div class="${cardClass}">
        ${showBack ? '<a href="/" data-link class="portal-login-back" aria-label="Volver al inicio">×</a>' : ''}
        ${showIcon ? '<div class="portal-login-icon" aria-hidden="true">👤</div>' : '<p class="portal-eyebrow">Contrato</p>'}
        <${heading} class="portal-login-title">${title}</${heading}>
        <p class="portal-muted portal-login-lead">${lead}</p>
        <form id="${formId}" class="portal-login-form" novalidate>
          <div class="portal-field">
            <label class="portal-label" for="${emailId}">Email</label>
            <input class="portal-input" type="email" id="${emailId}" name="email" required autocomplete="username" placeholder="tu@empresa.com" />
          </div>
          <div class="portal-field">
            <label class="portal-label" for="${passwordId}">Contraseña</label>
            <input class="portal-input" type="password" id="${passwordId}" name="password" required autocomplete="current-password" minlength="8" placeholder="••••••••" />
          </div>
          <button type="submit" class="portal-btn portal-btn-primary portal-btn-block portal-btn-lg">
            ${submitLabel}
          </button>
        </form>
        <p id="${msgId}" class="portal-muted portal-form-msg" role="status"></p>
        <p class="portal-muted portal-login-foot">
          ¿Primera vez? <a href="/activar" data-link>Activa tu acceso</a>
        </p>
      </div>
    </div>`
}

export function bindClientLoginForm(root, { navigate, formId = 'client-login-form', msgId = 'client-login-msg' } = {}) {
  if (isClientLoggedIn()) {
    navigate('/mi-instalacion', { replace: true })
    return
  }

  const form = root.querySelector(`#${formId}`)
  const msg = root.querySelector(`#${msgId}`)
  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    if (!apiConfigured()) {
      if (msg) msg.textContent = 'Servicio no disponible.'
      return
    }
    const fd = new FormData(form)
    if (msg) msg.textContent = 'Entrando…'
    try {
      const data = await clientLogin(String(fd.get('email') || ''), String(fd.get('password') || ''))
      setClientSession({
        token: data.token,
        client: data.client,
        staff: data.staff,
        installations: data.installations,
        organizations: data.organizations,
        permissions: data.permissions,
        actor_type: data.actor_type,
      })
      navigate('/mi-instalacion', { replace: true })
    } catch (e) {
      if (msg) msg.textContent = e.message || 'No se pudo iniciar sesión.'
    }
  })

  setTimeout(() => form?.querySelector('input[type="email"]')?.focus(), 50)
}
